export default __webpack_public_path__ + "61f4654cc55fdca5e1a0ddf971ca07fc.jpeg";